package net.bothosting.docs.pages.faqs_and_info

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initAccount_server_recoveryPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("faqs_and_info/account_server_recovery.md", FrontMatterElement.EmptyMap))
}

@Page("/faqs_and_info/account-server-recovery")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Account_server_recoveryPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("account-server-recovery") }) {
        org.jetbrains.compose.web.dom.Text("Account/Server Recovery")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.CAUTION, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("IMPORTANT:")
            }
            org.jetbrains.compose.web.dom.Text(" You should ALWAYS keep the original files on your local device or cloud.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Recovering server or account data is possible only in a few cases and only within a specific time frame.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("recover-a-lost-account") }) {
        org.jetbrains.compose.web.dom.Text("Recover a Lost Account ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#recover-lost-account");attr("id", "recover-lost-account")}) {
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("bot-hosting.net lets you register and log in to the platform using your Discord account.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you lose your Discord account, you can try using the ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://bot-hosting.net/account-recovery") {
            org.jetbrains.compose.web.dom.Text("Account Recovery Page")
        }
        org.jetbrains.compose.web.dom.Text(".")
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.Text("This page asks you to do the following:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Log in with a new, empty account. It must have no coins and no servers.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Enter the email linked to your old Discord account and its user ID.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Confirm the action and follow the instructions in the email sent to the address you provided to transfer your account data to the new account.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you cannot get your old Discord account ID, you can open an account recovery ticket using only the email address.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you also lose access to the email address, the only way to recover the account is with a payment receipt from the site or from a ticket purchase made with LTC or PayPal. The payment receipt must show the unique payment ID to prove the purchase. This process is not automatic and can only be handled in a support ticket.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If none of those options are available to you, there is no way to recover your lost account.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("recover-server-data-after-deletion") }) {
        org.jetbrains.compose.web.dom.Text("Recover Server Data After Deletion ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#recover-server-after-deletion");attr("id", "recover-server-after-deletion")}) {
        }
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.WARNING, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Please note: recovery of server files is not always guaranteed, and it may not include every file or database you had on your server.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You can request server file recovery in a support ticket if fewer than 14 days have passed since the deletion date. Please keep in mind that the process is not instant or guaranteed, and it may take some time for an admin to be available for recovery.")
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Not sure when the server was deleted?")
        }
        org.jetbrains.compose.web.dom.Text(" Consider this: servers are suspended when renewal fails because there are not enough coins. They are deleted after 10 days. If you think fewer than 24 days have passed since the suspension, you can ask for recovery.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("recover-a-deleted-account") }) {
        org.jetbrains.compose.web.dom.Text("Recover a Deleted Account ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#recover-deleted-account");attr("id", "recover-deleted-account")}) {
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Recovering a deleted account is currently not possible.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br")
}
